import { render } from "./AddEditAuthorization.vue?vue&type=template&id=2e9f4106"
import script from "./AddEditAuthorization.vue?vue&type=script&lang=js"
export * from "./AddEditAuthorization.vue?vue&type=script&lang=js"

import "./AddEditAuthorization.vue?vue&type=style&index=0&id=2e9f4106&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__